import type { Search } from "../search";
import { getFacetFromFacetConfig } from "../search-filter-selectors";

export function encodeSearch(search: Search): string {
  const params = new URLSearchParams();

  if (search.query !== undefined) params.set("query", search.query);
  if (search.filters !== undefined) {
    search.filters?.forEach((filter) =>
      typeof filter === "string"
        ? params.append("filters", filter)
        : filter.forEach((filter) => params.append("filters", filter)),
    );
  }
  if (search.offset !== undefined) params.set("offset", String(search.offset));
  if (search.limit !== undefined) params.set("limit", String(search.limit));
  if (search.distinct !== undefined) params.set("distinct", search.distinct);
  if (search.attributesToRetrieve !== undefined) {
    search.attributesToRetrieve.forEach((attr) =>
      params.append("attributesToRetrieve", attr),
    );
  }
  if (search.facets !== undefined) {
    getFacetFromFacetConfig(search.facets, search.filters).forEach((facet) =>
      params.append("facets", facet),
    );
  }

  return params.toString();
}
